import { render, staticRenderFns } from "./Link.global.vue?vue&type=template&id=0d2541e7&scoped=true&lang=pug&"
import script from "./Link.global.vue?vue&type=script&lang=ts&"
export * from "./Link.global.vue?vue&type=script&lang=ts&"
import style0 from "./Link.global.vue?vue&type=style&index=0&id=0d2541e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2541e7",
  null
  
)

export default component.exports